import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";
import { SoftButton } from "@ui/components/SoftButton";
import { tv } from "@ui/lib/tv";
import type { UseCardCarouselReturn } from "@ui/primitives/Carousel";

const cardCarouselArrows = tv({
  slots: {
    root: "flex items-center gap-2",
    button: "disabled:cursor-not-allowed disabled:opacity-40",
  },
});

export interface CardCarouselArrowsProps {
  /** The `useCardCarousel()` result — the same object whose `ref` is attached to the `<CardCarousel>`. */
  carousel: UseCardCarouselReturn;
  className?: string;
}

/** Prev/next paged-scroll arrows for a `<CardCarousel>`. Render wherever fits the
 *  surrounding layout (typically the section heading row, hidden below `md`). */
export function CardCarouselArrows({ carousel, className }: CardCarouselArrowsProps) {
  const { canScrollLeft, canScrollRight, scrollLeft, scrollRight } = carousel;
  const styles = cardCarouselArrows();

  return (
    <div className={styles.root({ className })}>
      <SoftButton
        aria-label={t("components.card_carousel.scroll_left")}
        className={styles.button()}
        isDisabled={!canScrollLeft}
        onPress={scrollLeft}
      >
        <Icon name="left" size="16" />
      </SoftButton>
      <SoftButton
        aria-label={t("components.card_carousel.scroll_right")}
        className={styles.button()}
        isDisabled={!canScrollRight}
        onPress={scrollRight}
      >
        <Icon name="right" size="16" />
      </SoftButton>
    </div>
  );
}
